import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { StandardModule  } from './core/components/standard/standard.module';
import { DonutModule  } from './core/components/donut/donut.module';
import { RadarModule  } from './core/components/radar/radar.module';
import { ToastNotificationsModule } from 'ngx-toast-notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    StandardModule,
    DonutModule,
    RadarModule,
    BrowserAnimationsModule,
    ToastNotificationsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
